import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { editAssignment, deleteAssignment } from '../../../../redux';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import { Link, useNavigate } from 'react-router-dom';
import "../index.css";

function EditAssignmentForm (props) {
    const {
        assignment,
        editAssignment,
        assignments,
        history,
        deleteAssignment,
        teacherEvaluations,
    } = props;

    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState("");
    const [name, setName] = useState("");
    const [dueDate, setDueDate] = useState(new Date());
    const [status, setStatus] = useState("");
    const [evaluationsRequired, setEvaluationsRequired] = useState(0);
    const [allowResubmissions, setAllowResubmissions] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!assignment || !assignment._id) return;
        setName(assignment.name);
        setDueDate(assignment.dueDate ? new Date(assignment.dueDate) : new Date());
        setStatus(assignment.status);
        setEvaluationsRequired(assignment.evaluationsRequired);
        setAllowResubmissions(assignment.allowResubmissions);
    }, []);

    const handleChange = (e) => {
        if(e.target.name === "name"){
            setName(e.target.value);
        }
        else if(e.target.name === "evaluationsRequired"){
            setEvaluationsRequired(e.target.value);
        }
    }

    const handleDateChange = (e, dueDate) => {
        setDueDate(dueDate);
    };

    const handleResubmissionsChange = (e) => {
        setAllowResubmissions(e.target.checked);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name === "" ||
            dueDate === null ||
            evaluationsRequired === null ||
            status === null) {
            setErrMsg("Please fill out all the fields.");
        } else {
            editAssignment(
                {
                    name,
                    dueDate,
                    status,
                    evaluationsRequired,
                    allowResubmissions
                },
                assignment._id,
                assignments
            );
            setErrMsg("");
            navigate("/teacher");
        }
    }

    const handleDropdownChange = (e) => {
        setStatus(e.target.innerText.trim());
    }

    const handleDelete = () => {
        deleteAssignment(
            assignment._id,
            assignments,
            teacherEvaluations
        );
        navigate("/teacher");
    }

    if (!assignment || !assignment._id) {
        return (
            <div className="assignmentForm">
                <Link to="/teacher" className="backButton">
                    <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Dashboard
                </Link>
                <p>No assignment selected. Please return to the dashboard.</p>
            </div>
        );
    }

    return (
        <div className="assignmentForm">
            <Link to="/teacher" className="backButton">
                <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <h1>Edit Assignment</h1>
            <TextField
                hintText="Assignment Title"
                name="name"
                onChange={handleChange}
                value={name}
                style={{paddingTop: "0px", paddingBottom: "20px"}}
            />
            <br/>
            <DatePicker
                hintText={assignment && assignment.dueDate ? assignment.dueDate.slice(0, 10) : ""}
                textFieldStyle={{paddingTop: "0px", paddingBottom: "20px"}}
                onChange={handleDateChange}
                value={dueDate}
                hintStyle={{color: "black"}}
            />
            <TextField
                hintText="# of Evaluations Required"
                name="evaluationsRequired"
                onChange={handleChange}
                value={evaluationsRequired}
                style={{paddingTop: "0px", paddingBottom: "20px"}}
                type="number"
            />
            <br/>
            <SelectField
                hintText={"Status"}
                name="status"
                value={status}
                onChange={handleDropdownChange}
                labelStyle={{textAlign: "left"}}
                floatingLabelStyle={{paddingLeft: "0%"}}
                style={{textAlign: "left", marginTop: "-10px"}}
            >
                <MenuItem
                    key="Inactive"
                    value="Inactive"
                    primaryText="Inactive"
                    id="status"
                />
                <MenuItem
                    key="Assigned"
                    value="Assigned"
                    primaryText="Assigned"
                    id="status"
                />
                <MenuItem
                    key="Reviewed"
                    value="Reviewed"
                    primaryText="Reviewed"
                    id="status"
                />
                <MenuItem
                    key="Graded"
                    value="Graded"
                    primaryText="Graded"
                    id="status"
                />
            </SelectField>
            <br/>
            <Checkbox
                label="Allow Resubmissions"
                checked={allowResubmissions}
                onCheck={handleResubmissionsChange}
                style={{maxWidth: "240px", margin: "0 auto"}}
            />
            <br/>
            <button onClick={handleDelete} className="actionButton" style={{marginTop: "20px", width: "150px"}}>Delete</button>
            <form onSubmit={handleSubmit}>
                <button type="submit" className="pink saveButton" style={{marginTop: "30px"}}>Save</button>
            </form>
            <p className="errorMessage">{errMsg}</p>
        </div>
    );
}

export default connect(state => state.root, { editAssignment, deleteAssignment })(EditAssignmentForm);
